import React, { useEffect, useRef, useState } from "react";
import { FEED_ENTRY_POINT } from "@infrastructure/Events/EntryPointEvents";
import {
    GroupInput,
    WRAPPER_ACTIONS_ENUM,
    WrapperParams,
} from "@shared/Types/GroupEntry.types";
import { usePostListModalStore } from "../Modals/PostListModal/PostListModalStore";
import { isRunningInNativeAndriod } from "@infrastructure/Helpers/IsRunningInNativeApp";
import { publish } from "@infrastructure/Events/EventBus";
import { OPEN_PRESENTER } from "../Post/PostForm/events";
import { prepareSearchCriteriaWithoutCaching } from "@infrastructure/Services/ApiUtility";
import { PostListFacade } from "./PostListFacade";
import { usePortalReference } from "@infrastructure/Persistence/PortalReferenceStore";
import { PostDetailsModal } from "../Modals/PostDetailsModal/PostDetailsModal";

export function PostListEntryComponent() {
    const { setIsPostListModalOpen } = usePostListModalStore();
    const isRunningInAndroid = isRunningInNativeAndriod();
    const { setPostListAction } = usePostListModalStore();
    const [groupData, setGroupData] = useState<GroupInput>();
    useEffect(() => {
        window.addEventListener(
            FEED_ENTRY_POINT,
            feedEntryPointListener,
            false,
        );

        document.isFeedReady = () => {
            return true;
        };

        return () => {
            window.removeEventListener(
                FEED_ENTRY_POINT,
                feedEntryPointListener,
            );
            document.isFeedReady = () => {
                return false;
            };
        };
    }, []);

    function onPostListModalClick(
        group: GroupInput,
        presenterAdditionalParams = {},
    ) {
        if (
            isRunningInAndroid &&
            window.WebtipAppBridge &&
            WebtipAppBridge.openFeedPresenter
        ) {
            publish({ name: OPEN_PRESENTER });
            WebtipAppBridge.openFeedPresenter(
                "Community",
                `${
                    process.env.REACT_APP_POST_MODAL_PAGE +
                    prepareSearchCriteriaWithoutCaching({
                        groupId: group.id,
                        ...presenterAdditionalParams,
                    })
                }`,
                false,
            );
        } else {
            setGroupData({ ...group, showAvatar: true });
            setIsPostListModalOpen(true, group.id);
        }
    }

    function feedEntryPointListener(event) {
        const group: GroupInput = event.detail.groupData;
        if (
            group?.wrapperParams?.action &&
            [
                WRAPPER_ACTIONS_ENUM.OPEN_POST_COMMENT,
                WRAPPER_ACTIONS_ENUM.OPEN_POST_LIST,
                WRAPPER_ACTIONS_ENUM.OPEN_POST_DETAILS,
            ].includes(group.wrapperParams.action)
        ) {
            const params: WrapperParams = {
                action: group.wrapperParams.action,
                postId: group.wrapperParams.postId,
                commentId: group.wrapperParams.commentId,
            };
            setPostListAction(params);
            onPostListModalClick(group, params);
        } else {
            onPostListModalClick(group);
        }
    }

    const portalRef = useRef<HTMLDivElement>();
    const { setPortalRef } = usePortalReference();
    useEffect(() => {
        setPortalRef(portalRef);
    }, [portalRef]);

    return groupData ? (
        <>
            <PostListFacade groupData={groupData} />
            <PostDetailsModal />
            <div id={"portalPostsList"} ref={portalRef}></div>
        </>
    ) : (
        <></>
    );
}
